export default "__VITE_ASSET__C9DYrR$u__"